
import React from "react";
import { Guide } from "@/types/guides";
import { GuideCard } from "./GuideCard";

interface GuideListProps {
  guides: Guide[];
  isLoading: boolean;
  defaultCoverImage: string;
  onPreview: (e: React.MouseEvent, guide: Guide) => void;
  onDownload: (e: React.MouseEvent, guide: Guide) => void;
}

export function GuideList({ guides, isLoading, defaultCoverImage, onPreview, onDownload }: GuideListProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-grandpal-green-dark"></div>
      </div>
    );
  }

  if (guides.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-grandpal-gray text-lg">No guides available yet.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {guides.map(guide => (
        <GuideCard 
          key={guide.id}
          guide={guide}
          defaultCoverImage={defaultCoverImage}
          onPreview={onPreview}
          onDownload={onDownload}
        />
      ))}
    </div>
  );
}
